module.exports = __webpack_public_path__ + "static/media/about-us.08cd804e.png";